// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_Compat from "../Effect.Aff.Compat/index.js";
var getCurrentPosition = /* #__PURE__ */ (function () {
    var $4 = Data_Functor.map(Effect_Aff.functorAff)(function (v) {
        return {
            lat: v.latitude,
            lon: v.longitude
        };
    });
    return function ($5) {
        return $4(Effect_Aff_Compat.fromEffectFnAff($foreign["_getCurrentPositionAff"]($5)));
    };
})();
var defaultOptions = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 30000
};
export {
    getCurrentPosition,
    defaultOptions
};
//# sourceMappingURL=index.js.map
